import { compile, compileG } from "./compile/emit.js";
import { vop } from "./vop.js";
const $ = (dim) => magSq.add(
  dim,
  compile(dim, ([a]) => `${a}*${a}`, "a", "a", "", "+", "return ", ";")
);
const magSq = vop();
magSq.default(
  compileG(([a]) => `sum+=${a}*${a};`, "a", void 0, "sum", "let sum=0;")
);
const magSq2 = $(2);
const magSq3 = $(3);
const magSq4 = $(4);
export {
  magSq,
  magSq2,
  magSq3,
  magSq4
};
